import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  weatherUpdateRequested: ['lng', 'lat'],
  weatherUpdateFulfilled: ['json'],
  weatherUpdateFailed: [],
  reset: []
})

export const WeatherTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  fetching: false
})

// Redux reducers
export const weatherUpdateRequested = (state, { service }) => {
  return state.merge({ fetching: true })
}

export const weatherUpdateFulfilled = (state, { json }) => {
  return state.merge({ ...json })
}

export const weatherUpdateFailed = (state, { error }) => {
  console.log(error)
  return state.merge({ error })
}

export const weatherReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.WEATHER_UPDATE_REQUESTED]: weatherUpdateRequested,
  [Types.WEATHER_UPDATE_FULFILLED]: weatherUpdateFulfilled,
  [Types.WEATHER_UPDATE_FAILED]: weatherUpdateFailed,
  [Types.RESET]: weatherReset
})



// WEBPACK FOOTER //
// ./src/redux/weatherRedux.js